export const EMPLOYEE_SKILLS_REQUEST = "EMPLOYEE_SKILLS_REQUEST";
export const EMPLOYEE_SKILLS_SUCCESS = "EMPLOYEE_SKILLS_SUCCESS";
export const EMPLOYEE_SKILLS_FAIL = "EMPLOYEE_SKILLS_FAIL";
